<app-share-button ></app-share-button>

<div class="row">
    <div class="col-md-8  ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>
                    </h2>
                </div>
                <div class="col-md-2 col2 "> <a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>  
                </div>
                <!-- <div class="col-md-2 col2"><button class="btn share"><img src="./assets/share (5).svg"
                            style="width: 30px;" alt=""></button>
                </div> -->
                <div class="col-md-12" (mouseover)="showpayment(true,'1')" (mouseout)="showpayment(false,'1')" id="1">

                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')"
                    id="2">
                    <h2>Onboarding Process of PayG for Sales Partners </h2>
                    <label for="" class="mt-2">The onboarding process for Sales Partners at PayG is structured to ensure a
                        smooth integration into our payment gateway services while maintaining compliance and enhancing
                        the Sales Partner's ability to serve their clients effectively. Below is a detailed outline of each
                        step involved in the process.</label>
                </div>
                <div class="col-md-12 mt-5  " (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')"
                    id="3">


                    <h4 class="mt-4"><b>Step 1: Initial Registration </b></h4>
                    <label for="">1. Visit the Website </label><br>
                    <label for="">Navigate to our official website at <a style="color: #09BCE1;" href="https://payg.in/">www.payg.in</a> </label>

                    <div class="row">
                        <div class="col-md-12 mt-3 " style="text-align: center;">
                            <img src="./assets/visitorweb.png" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label class="mt-2">2. Login or Register</label><br>
                    <label for="">Click on the "Login" button, then select "Sales Partner." If you are a new user, click on
                        “Register as Sales Partner” </label><br>

                    <div class="row">
                        <div class="col-md-12 mt-3 " style="text-align: center;">
                            <img src="./assets/loginreg.jpg" width="100%" height="100%" alt="">
                        </div>
                    </div>


                </div>
                <h4 class="mt-4"><b>Step 2: Filling Out Registration Details </b></h4>
                <label for="">1. Basic Information  </label>
                <ul style="padding: 1% 0% 1% 6%;">
                    <li>Name </li>
                    <li>Email Address</li>
                    <li>Mobile Number</li>
                    <li>Company Name </li>
                    <li>PAN Card </li>
                </ul>
                <label for=""> - After filling the information, click on the "Register" button
                </label>

                <div class="row">
                    <div class="col-md-12 mt-3">
                        <img src="./assets/Register.png" width="100%" height="100%" alt="">
                    </div>
                </div>


                <label for="" class="mt-3">2. OTP Verification </label>
                <label for=""> - Enter the One-Time Password (OTP) sent to your registered mobile number. </label>


                <div class="row">
                    <div class="col-md-12 mt-3">
                        <img src="./assets/otphere.jpg" width="100%" height="100%" alt="">
                    </div>
                </div>

                <label for="" class="mt-3"> - Create a strong password for your account.</label>


                <div class="row">
                    <div class="col-md-12 mt-3">
                        <img src="./assets/strongpass.png" width="100%" height="100%" alt="">
                    </div>
                </div>

                <h4 class="mt-4"><b>Step 3: Business Information </b></h4>
                <label for="">1. Business Address </label>
                <p> - Provide your complete business address, including:</p>
                <p>- State </p>
                <p> - Zip Code </p>
                <p> - City Name </p>
                <div class="row">
                    <div class="col-md-12 mt-3">
                        <img src="./assets/Screenshot 2024-11-04 191719.png" width="100%" height="100%"
                            alt="">
                    </div>
                </div>

                <label for="" class="mt-3">2. Business Details</label>
                <p>- Fill in additional business information such as:</p>
                <p> - Company Name</p>
                <p> - Annual Turnover</p>
                <p> - Website URL </p>
                <p> - Company PAN Number (Permanent Account Number) </p>
                <div class="row">
                    <div class="col-md-12 mt-3">
                        <img src="./assets/Screenshot 2024-11-04 144859.png" width="100%" height="100%"
                            alt="">
                    </div>
                </div>

                <label for="" class="mt-3">3. Owner’s Details  </label>
                <p> - Enter details of the company owner, including: </p>
                <p> - Name </p>
                <p> - Contact Information </p>
                <p> - This step is crucial for verifying the authenticity of the business. </p>
                <div class="row">
                    <div class="col-md-12 mt-3">
                        <img src="./assets/Screenshot 2024-11-04 144928.png" width="100%" height="100%"
                            alt="">
                    </div>
                </div>



                <label for="" class="mt-3">4: Bank Details </label>
                <label>1. Bank Information </label>
                <p> - Provide the bank account details where funds will be settled, including: </p>
                <p> - Bank Name </p>
                <p> - Account Number </p>
                <p> - IFSC Code </p>
                <div class="row">
                    <div class="col-md-12 mt-3">
                        <img src="./assets/Screenshot 2024-11-04 144949.png" width="100%" height="100%"
                            alt="">
                    </div>
                </div>

                <label for="" class="mt-3"> 5: Document Upload </label>
                <label>1. Document Submission </label>
                <p> - Upload necessary documents to support your application. This may include:</p>
                <p> - Business Registration Certificate </p>
                <p> - PAN Card </p>
                <p> - Address Proof </p>
                <p>- Bank Statement </p>
                <p> - Ensure that all documents are clear and legible for smooth verification</p>
                <div class="row">
                    <div class="col-md-12 mt-3">
                        <img src="./assets/Screenshot 2024-11-04 145016.png" width="100%" height="100%"
                            alt="">
                    </div>
                </div>

                <h4 class="mt-4"><b>Step 4: Completion of Registration </b></h4>
                <label for="">1. Registration Confirmation </label>
                <p>- Once all the information is filled and documents are uploaded, your registration will be processed.
                </p>

                <div class="row">
                    <div class="col-md-12 mt-3">
                        <img src="./assets/Screenshot 2024-11-04 191331.png" width="100%" height="100%"
                            alt="">
                    </div>
                </div>
                <p class="mt-3"> - You will receive a confirmation notification regarding the status of your
                    application. </p>
                <label for="">2. Document Verification </label>
                <p> - PayG’s team will review and verify the submitted documents. This step is essential to ensure
                    compliance and authenticity. </p>


                <h4 class="mt-4"><b>Step 5: Account Activation</b></h4>
                <h4>1. Login to Your Account </h4>
                <p>- After successful verification of your documents, you will receive a notification confirming your
                    registration approval.
                </p>
                <p>  - You can now log in to your account using your registered credentials.</p>
                <div class="col-md-12 mt-3">
                    <img src="./assets/Screenshot 2024-11-04 191519.png" width="100%" height="100%" alt="">
                </div>


                <label for="" class="mt-3">Once logged in, you will gain access to our payment solutions, APIs, and
                    other resources
                    necessary for integration and operation. </label>
                <label for="">By following these steps, Sales Partners can effectively onboard with PayG and leverage our
                    payment
                    solutions to expand their business offerings and serve their clients efficiently.</label>




            </div>
        </div>
    </div>
    <div class="col-md-4 hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        Table of Contents:
                    </h5>

                </div>
                <div class="col-md-12 mt-2">
                    <!-- <a href="#1">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                    alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span class="videoHover" style="cursor: pointer;"
                                    [ngClass]="{'video':colors=='1'}" (click)="color('1')"
                                    >
                                    Introduction to
                                    Payment Gateways
                                </span>
                              
                            </div>
                        </div>
                    </a> -->
                </div>
                <div class="col-md-12 ">
                    <a href="#2">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='2'}"
                                    (click)="color('2')">Introduction </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 ">
                    <a href="#3">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')">
                                    Registration  Process </span>

                            </div>
                        </div>
                    </a>
                </div>
                <!-- <div class="col-md-12 ">
                    <a href="#4">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='4'}"
                                    (click)="color('4')">Benefits of Being a Sales Partner </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 ">
                    <a href="#5">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='5'}"
                                    (click)="color('5')"> How Sales Partners Can Benefit from PayG</span>

                            </div>
                        </div>
                    </a>
                </div> -->

            </div>
        </div>
    </div>



    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8">
                <a [routerLink]="['/introduction-reseller']"><button class="btn btn-color"
                        (click)="menues('Creating Profile')"> <img src="./assets/Arrow 3.svg" alt=""> &nbsp;
                        Introduction

                        &nbsp;</button></a>

            </div>
            <div class="col-md-4 ">
                <a [routerLink]="['/login-with-qr']"> <button class="btn btn-color">Login with QR
                        &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
            </div>
        </div>
    </div>
</div>